<template>
  <div class="detail-container">
    <h3 class="title">{{ content.title }}</h3>
    <van-cell-group>
      <template>
        <div v-if="content.type == 'Array'">
          <div v-for="el in form[content.key]" class="detail-item">
            <div v-for="item in content.rows" :key="item.key">
              <div v-if="item.editable && type == 'edit'">
                <van-field
                  v-if="
                    item.type === 'dialog' &&
                    item.component === 'DateTimePicker'
                  "
                  :label="item.label"
                  v-model="el[item.key]"
                  :placeholder="`请输入${item.label}`"
                  @click="showDialog(item)"
                />
                <van-field
                  v-else
                  :label="item.label"
                  v-model="el[item.key]"
                  :placeholder="`请输入${item.label}`"
                  @change="inputChange()"
                />
              </div>
              <van-cell v-else :title="item.label" :value="el[item.key]" />
            </div>
          </div>
        </div>
        <div v-else v-for="item in content.rows" :key="item.key">
          <div v-if="item.editable && type == 'edit'">
            <van-field
              v-if="
                item.type === 'dialog' && item.component === 'DateTimePicker'
              "
              :label="item.label"
              v-model="form[item.key]"
              :placeholder="`请输入${item.label}`"
              @click="showDialog(item)"
            />
            <van-field
              v-else
              :label="item.label"
              :type="item.type"
              v-model="form[item.key]"
              :placeholder="`请输入${item.label}`"
              @change="inputChange()"
            />
          </div>
          <van-cell v-else :title="item.label" :value="form[item.key]" />
        </div>
      </template>
      <slot></slot>
    </van-cell-group>
    <DateTimePicker
      value-format="yyyy-MM-dd"
      :showPicker="showDatePicker"
      @confirm="onDatePickerConfirm"
      @cancel="showDatePicker = false"
    ></DateTimePicker>
  </div>
</template>

<script>
import DateTimePicker from "@/components/dateTimePicker.vue";

export default {
  name: "DetailPage",
  components: { DateTimePicker },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    content: {
      type: Object,
      default: () => {},
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDatePicker: false,
      dialogKey: "",
      visible: "",
    };
  },
  computed: {
    form() {
      return this.data;
    },
  },
  mounted() {
    
  },
  methods: {
    inputChange() {
      this.$emit("change", this.form);
    },
    showDialog(item) {
      this.dialogKey = item.key;
      this.visible = item.visible;
      this[item.visible] = true;
    },
    openDateTimePicker(key) {
      this.dialogKey = key;
      this.showDatePicker = true;
    },
    onDatePickerConfirm(val) {
      if (!val) return;
      this.form[this.dialogKey] = val;
      this[this.visible] = false;
      this.inputChange();
    },
  },
};
</script>

<style lang="less" scoped>
@main-color: #4c9673;

.detail-container {
  padding: 16px;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 16px;
  color: #4c9673;
  border-bottom: 1px solid lighten(#4c9673, 50%);
}

.van-field {
  --van-field-label-color: #4c9673;
  --van-field-error-message-color: lighten(@main-color, 20%);
}

.van-cell {
  --van-cell-title-color: #4c9673;
}
.detail-item {
  border-bottom: 1px solid #ccc;
}
</style>
